import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { ScrollService } from '@effy-tech/acquisition-core/shared';
import { Observable, defaultIfEmpty, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollProgressPageService {
  private readonly document = inject(DOCUMENT);
  private readonly scrollService = inject(ScrollService);

  readonly progress$: Observable<number> = this.scrollService.scroll$.pipe(
    map(() => this.computeProgress()),
    defaultIfEmpty(0)
  );

  private computeProgress() {
    const scrollPosition = this.document.defaultView.scrollY;
    const maxScroll = this.document.documentElement.scrollHeight - this.document.defaultView.innerHeight;
    const hasNoScroll = this.document.documentElement.scrollHeight === this.document.defaultView.innerHeight;
    return hasNoScroll ? 100 : (scrollPosition / maxScroll) * 100;
  }
}
